module.exports = __webpack_public_path__ + "static/media/topbanner.220b7f00.png";